export interface MinutesInterval {
  startMinutes: number;
  endMinutes: number;
}

// Свободные отрезки шага [slotStart, slotEnd) за вычетом занятых интервалов
// (записи, перерывы). Пусто, если шаг занят целиком.
export const getFreeSegments = (
  slotStartMinutes: number,
  slotEndMinutes: number,
  busyIntervals: MinutesInterval[]
): MinutesInterval[] => {
  const slotIntervals = busyIntervals
    .filter(
      ({ startMinutes, endMinutes }) =>
        slotStartMinutes < endMinutes && slotEndMinutes > startMinutes
    )
    .sort((left, right) => left.startMinutes - right.startMinutes);

  const segments: MinutesInterval[] = [];
  let cursorMinutes = slotStartMinutes;

  for (const { startMinutes, endMinutes } of slotIntervals) {
    if (startMinutes > cursorMinutes) {
      segments.push({ startMinutes: cursorMinutes, endMinutes: startMinutes });
    }

    cursorMinutes = Math.max(cursorMinutes, endMinutes);

    if (cursorMinutes >= slotEndMinutes) {
      return segments;
    }
  }

  segments.push({ startMinutes: cursorMinutes, endMinutes: slotEndMinutes });

  return segments;
};

// Отрезок, по которому кликнули, а если клик пришёлся на занятое время —
// ближайший к нему.
export const findFreeSegmentAt = (
  segments: MinutesInterval[],
  minutes: number
): MinutesInterval | undefined => {
  const getDistance = ({ startMinutes, endMinutes }: MinutesInterval) => {
    if (minutes < startMinutes) return startMinutes - minutes;
    if (minutes >= endMinutes) return minutes - endMinutes;

    return 0;
  };

  return segments.reduce<MinutesInterval | undefined>(
    (closest, segment) =>
      !closest || getDistance(segment) < getDistance(closest)
        ? segment
        : closest,
    undefined
  );
};
